import { useState } from 'react'
import {
  Button,
  Grid,
  GridContainer,
  Input,
  Modal,
  useToaster,
} from '@enterprise-ui/canvas-ui-react'
import {
  pauseAllNotifications,
  pauseNotification,
} from '../../services/requests'
import { DatePicker } from '@enterprise-ui/canvas-ui-react-datepicker'
import { format } from 'date-fns'
import {
  TOASTER_DEFAULTS,
  getCurrentUTCDateString,
} from '../../globalConfig/constants'

export const ManageNotificationsPauseModal = (props) => {
  const { showModal, onClose, updateCurrentNotifications, notificationId } =
    props
  const makeToast = useToaster()
  const [dateRangeIsVisible, setDateRangeIsVisibile] = useState(false)
  const [dateRange, setDateRange] = useState(null)
  const [selectedInput, setSelectedInput] = useState('resume')

  const handlePauseNotification = (notificationId) => {
    const sendFailureToast = (isAll) => {
      makeToast({
        ...TOASTER_DEFAULTS,
        type: 'error',
        heading: 'Error',
        message: isAll
          ? 'Failed to pause all notifications.'
          : 'Failed to pause notification.',
      })
    }

    let formattedStartDate
    let formattedEndDate

    if (dateRange) {
      formattedStartDate = format(new Date(dateRange?.startDate), 'yyyy-MM-dd')
      formattedEndDate = format(new Date(dateRange?.endDate), 'yyyy-MM-dd')
    }

    if (notificationId === null) {
      pauseAllNotifications(formattedStartDate, formattedEndDate)
        .then((response) => {
          if (response?.status === 200) {
            updateCurrentNotifications(response.data.notificationRules)
          } else {
            sendFailureToast(true)
          }
        })
        .catch(() => {
          sendFailureToast(true)
        })
    } else {
      pauseNotification(notificationId, formattedStartDate, formattedEndDate)
        .then((response) => {
          if (response?.status === 200) {
            updateCurrentNotifications(response.data)
          } else {
            sendFailureToast(false)
          }
        })
        .catch(() => {
          sendFailureToast(false)
        })
    }
  }

  return (
    <>
      <Modal
        className="hesp-pause-modal"
        data-testid="pause-notification-modal"
        headingText={
          notificationId === null
            ? 'Pause All Notifications'
            : 'Pause Notification'
        }
        isVisible={showModal}
        size="dense"
        onRefuse={() => {
          onClose()
          setDateRange(null)
          setDateRangeIsVisibile(false)
          setSelectedInput('resume')
        }}
      >
        <div className="hc-pa-normal hc-ma-normal">
          <GridContainer>
            <Grid.Item xs={12}>
              <Input.Radio
                style={{ marginBottom: '12px' }}
                data-testid={'pause-notification'}
                id={'pause-notification'}
                options={[
                  {
                    value: 'resume',
                    label: 'Until Resume',
                  },
                  {
                    value: 'date-range',
                    label: 'Date Range',
                  },
                ]}
                onUpdate={(id, value) => {
                  if (value === 'resume') {
                    setSelectedInput(value)
                    setDateRange(null)
                    setDateRangeIsVisibile(false)
                  } else {
                    setSelectedInput(value)
                    setDateRangeIsVisibile(true)
                  }
                }}
                value={selectedInput}
              />
              {dateRangeIsVisible && (
                <DatePicker
                  key="pause-range"
                  id="pause-range"
                  data-testid="pause-range"
                  type="gregorian-range"
                  label="Date Range"
                  disableDates={{
                    before: getCurrentUTCDateString(),
                  }}
                  onUpdate={(id, value) => setDateRange(value)}
                />
              )}
            </Grid.Item>
          </GridContainer>
          <Grid.Container direction="row-reverse" spacing="dense">
            <Grid.Item>
              <Button
                data-testid="pause-button"
                type="primary"
                disabled={
                  dateRangeIsVisible &&
                  !dateRange?.startDate &&
                  !dateRange?.endDate
                }
                onClick={() => {
                  handlePauseNotification(notificationId)
                  onClose()
                  setDateRange(null)
                  setDateRangeIsVisibile(false)
                  setSelectedInput('resume')
                }}
              >
                Pause
              </Button>
            </Grid.Item>
            <Grid.Item>
              <Button
                type="secondary"
                onClick={() => {
                  onClose()
                  setDateRange(null)
                  setDateRangeIsVisibile(false)
                  setSelectedInput('resume')
                }}
              >
                Cancel
              </Button>
            </Grid.Item>
          </Grid.Container>
        </div>
      </Modal>
    </>
  )
}
